// common container
.dogTrainerChat {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: #fffbf1;
  overflow-y: scroll;
  overscroll-behavior: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

// main wrapper
.mainWrapper {
  width: 100%;
  max-width: 450px;
  animation: fadeIn 0.4s 0.4s ease-out both;

  .imageWrapper {
    width: 100%;
    padding: 20px 0 0 0;

    img {
      width: 100%;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .labelWrapper {
    margin-top: 16px;
    width: 100%;
    height: 32px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .label {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 8px 6px 12px;
      border-radius: 32px;
      border: 0.5px solid rgba(255, 255, 255, 0);
      background: var(--ed-brand, #ae66f6);
      box-shadow: 1px -3px 16px 0 rgba(255, 255, 255, 0.6) inset;

      p {
        color: #fffbf2;
        font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
          sans-serif);
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        text-transform: uppercase;

        @at-root html[lang='it'] & {
          font-size: 15px;
        }
      }

      span {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
        background-image: url('./img/icon1.svg');
        background-size: 16.66px;
        background-repeat: no-repeat;
        background-position: center center;
        margin-left: 4px;
      }
    }
  }

  .titleWrapper {
    margin-top: 13px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;

    .title {
      color: #221e1a;
      text-align: center;
      font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
        sans-serif);
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 34px;
      letter-spacing: -0.4px;
    }
  }

  .subtitleWrapper {
    margin-top: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;

    .subtitle {
      color: #221e1a;
      text-align: center;
      font-size: 17px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.4px;
    }
  }

  .cardWrapper {
    width: 100%;
    padding: 0 20px;

    .card {
      position: relative;
      min-height: 281px;
      display: flex;
      padding: 14px 14px 7px 14px;
      border-radius: 24px;
    }

    .cardLabelWrapper {
      width: 100%;
      height: 28px;
      position: absolute;
      left: 0;
      top: -15px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .cardHeader {
      width: 100%;
    }

    .cardText {
      color: #7a7670;
      font-size: 12px;
      font-weight: 510;
      line-height: 16px;
    }

    .cardLines {
      margin-top: 4px;
      margin-bottom: 7px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 9px;
    }

    .cardLine {
      width: calc(33% - 5px);
      border-radius: 3px;
    }

    .cardItems {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
    }

    .cardItem {
      border-top: 1px solid var(--ed-border, rgba(41, 160, 115, 0.15));
      width: 100%;
      min-height: 56px;
      display: flex;
      padding: 15px 0 16px 0;
    }

    .cardItemImg {
      width: 24px;
      height: 24px;
      min-width: 24px;
      min-height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      background-size: 24px;
      background-repeat: no-repeat;
      background-position: center center;
    }

    .cardItemText {
      color: #221e1a;
      font-size: 15px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0.2px;
    }

    .card1 {
      margin-top: 40px;
      background: #e8f2e1;

      .cardLabel {
        width: auto;
        min-width: 102.84px;
        height: 28px;
        max-height: 28px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 5.36px 8.934px 5.361px 5.361px;
        border-radius: 28.59px;
        background: #29a073;
        box-shadow: 1px -3px 7px 0 rgba(255, 255, 255, 0.6) inset;
        transform: rotate(7deg);

        .cardLabelImage {
          width: 16.98px;
          height: 16.98px;
          min-width: 16.98px;
          min-height: 16.98px;
          background-image: url('./img/icon2.svg');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          margin-right: 3px;
        }

        .cardLabelText {
          color: #fffbf2;
          font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
            sans-serif);
          font-size: 12.508px;
          font-style: normal;
          font-weight: 700;
          line-height: 14.295px;
        }
      }

      .cardLine1 {
        background: linear-gradient(90deg, #c7d238 0%, #96c34b 100%);
      }

      .cardLine2 {
        background: linear-gradient(90deg, #96c34b 0%, #5aa15c 100%);
      }

      .cardLine3 {
        background: linear-gradient(90deg, #5aa15c 0%, #2ba275 100%);
      }

      .cardItemImg1 {
        background-image: url('./img/iconItem1.svg');
      }

      .cardItemImg2 {
        background-image: url('./img/iconItem2.svg');
      }

      .cardItemImg3 {
        background-image: url('./img/iconItem3.svg');
      }

      .cardItemImg4 {
        background-image: url('./img/iconItem4.svg');
      }
    }

    .card2 {
      margin-top: 24px;
      background: #f2ede1;

      .cardLabelWrapper {
        top: -17px;
      }

      .cardLabel {
        width: auto;
        min-width: 102.84px;
        height: 28px;
        max-height: 28px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 5.36px 8.934px 5.361px 5.361px;
        border-radius: 28.59px;
        background: #e17421;
        box-shadow: 1px -3px 7px 0 rgba(255, 255, 255, 0.6) inset;
        transform: rotate(-3deg);

        .cardLabelImage {
          width: 16.98px;
          height: 16.98px;
          min-width: 16.98px;
          min-height: 16.98px;
          background-image: url('./img/icon3.svg');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          margin-right: 3px;
        }

        .cardLabelText {
          color: #fffbf2;
          font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
            sans-serif);
          font-size: 12.508px;
          font-style: normal;
          font-weight: 700;
          line-height: 14.295px;
        }
      }

      .cardItem {
        border-top: 1px solid var(--ed-border, #eae5da);
      }

      .cardLine1 {
        background: linear-gradient(90deg, #c7d238 0%, #96c34b 100%);
      }

      .cardLine2 {
        background: linear-gradient(90deg, #96c34b 0%, #5aa15c 100%);
        opacity: 0.2;
      }

      .cardLine3 {
        background: linear-gradient(90deg, #5aa15c 0%, #2ba275 100%);
        opacity: 0.2;
      }

      .cardItemImg1 {
        background-image: url('./img/iconItem5.svg');
      }

      .cardItemImg2 {
        background-image: url('./img/iconItem6.svg');
      }

      .cardItemImg3 {
        background-image: url('./img/iconItem7.svg');
      }

      .cardItemImg4 {
        background-image: url('./img/iconItem8.svg');
      }
    }
  }

  .imageWrapper2 {
    margin-top: 10px;
    width: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 375px;
    }
  }

  .titleWrapper2 {
    margin-top: 16px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;

    .title {
      color: #221e1a;
      text-align: center;
      font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
        sans-serif);
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 34px;
      letter-spacing: -0.4px;
    }
  }

  .itemsWrapper {
    margin-top: 20px;
    margin-bottom: 23px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0 20px;

    .item {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .itemImage {
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        margin-right: 8px;
      }

      .itemText {
        color: #221e1a;
        font-size: 17px;
        font-weight: 400;
        line-height: 22px;
      }
    }

    .itemImage1 {
      background-image: url('./img/itemImage1.png');
    }

    .itemImage2 {
      background-image: url('./img/itemImage2.png');
    }

    .itemImage3 {
      background-image: url('./img/itemImage3.png');
    }

    .itemImage4 {
      background-image: url('./img/itemImage4.png');
    }
  }
}

// achieve wrapper
.achieveWrapper {
  width: 100%;
  background-color: #ffbb50;
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
  max-width: 450px;

  .achieveContent {
    max-width: 450px;
    min-height: 734px;
  }

  .titleWrapper3 {
    margin-top: 32px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;

    .title {
      color: #221e1a;
      text-align: center;
      font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
        sans-serif);
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 29px;
    }
  }

  .labelWrapper2 {
    margin-top: 22px;
    width: 100%;
    height: 45px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .label {
      width: auto;
      min-width: 125px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 12px 6px 12px;
      border-radius: 46px;
      border: 0.5px solid rgba(255, 255, 255, 0);
      background: var(--ed-brand, #ae66f6);
      box-shadow: 1px -3px 16px 0 rgba(255, 255, 255, 0.6) inset;

      p {
        color: #fffbf2;
        font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
          sans-serif);
        font-size: 24px;
        font-weight: 700;
        line-height: 29px;
        text-transform: uppercase;
      }
    }
  }

  .labelWrapper3 {
    margin-top: 23px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .label {
      width: 100%;
      max-width: 375px;
      // height: 448.5px;
      // max-height: 448.5px;
      background-image: url('./img/label.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      padding: 16px 30px 30px 30px;
    }

    .labelBlock1Wrapper {
      width: 100%;
      // height: 38px;
      display: flex;
      justify-content: center;
    }

    .labelBlock1 {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 12px;
      width: auto;
      max-width: 171px;
      height: 100%;
      border-radius: 14px;
      background: #29a073;
      box-shadow: 1px -3px 16px 0 rgba(255, 255, 255, 0.6) inset;
      border: 3px solid #fff6e8;
    }

    .labelBlock1Image1 {
      width: 16px;
      height: 16px;
      min-width: 16px;
      min-height: 16px;
      background-image: url('./img/stars1.svg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      margin-right: 4px;
    }

    .labelBlock1Image2 {
      width: 16px;
      height: 16px;
      min-width: 16px;
      min-height: 16px;
      background-image: url('./img/stars2.svg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      margin-left: 4px;
    }

    .labelBlock1Text {
      color: #fffbf2;
      font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
        sans-serif);
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;
      text-transform: uppercase;
      text-align: center;

      @at-root html[lang='ru'] & {
        font-size: 10px;
      }

      @at-root html[lang='pl'] & {
        font-size: 10px;
      }

      @at-root html[lang='uk'] & {
        font-size: 11px;
      }
    }

    .labelBlock2Wrapper {
      margin-top: 15px;
      width: 100%;
      height: 80px;
      display: flex;
      justify-content: center;
    }

    .labelBlock2 {
      position: relative;
      width: auto;
      min-width: 186px;
      border-radius: 24px;
      background: #fde5bf;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .fixed {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #221e1a;
        text-align: center;
        font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
          sans-serif);
        font-size: 50px;
        font-weight: 800;
        line-height: 60px;
      }

      .hidden {
        opacity: 0;
      }
    }

    .labelBlock2Cell {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 400px;
      will-change: transform;

      p {
        width: 100%;
        height: 80px;
        min-height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #221e1a;
        text-align: center;
        font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
          sans-serif);
        font-size: 50px;
        font-weight: 800;
        line-height: 60px;

        span {
          height: 100%;
          display: inline-flex;
          align-items: center;
        }

        .hidden {
          opacity: 0;
        }
      }
    }

    .labelBlock2Cell.isVisible {
      animation: scrollUp 7s ease-in-out both;
    }

    @keyframes scrollUp {
      0% {
        transform: translateY(0);
      }
      10% {
        transform: translateY(-80px);
      }
      25% {
        transform: translateY(-80px);
      }
      // 35% {
      //   transform: translateY(-160px);
      // }
      // 50% {
      //   transform: translateY(-160px);
      // }
      35% {
        transform: translateY(-240px);
      }
      50% {
        transform: translateY(-240px);
      }
      75% {
        transform: translateY(-240px);
      }
      85% {
        transform: translateY(-320px);
      }
      100% {
        transform: translateY(-320px);
      }
    }

    .labelBlock3Wrapper {
      margin-top: 15px;
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;

      .labelBlock3 {
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          color: #221e1a;
          text-align: center;
          font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
            sans-serif);
          font-size: 17px;
          font-weight: 600;
          line-height: 22px;
        }

        .labelBlock3Loader {
          width: 24px;
          height: 24px;
          min-width: 24px;
          min-height: 24px;
          background-image: url('./img/loader.svg');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          display: inline-block;
          margin-left: 2px;
          animation: spin 1s linear infinite;
          transform-origin: 50% 50%;
        }
      }

      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }
  }

  .labelBlock4Wrapper {
    margin-top: 46px;
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 20px;

    .labelBlock4PriceBlock {
      width: 100%;
      display: flex;
    }

    .labelBlock4PriceText {
      width: 70%;
      color: #221e1a;
      font-size: 17px;
      font-weight: 400;
      line-height: 22px;

      @at-root html[lang='fr'] & {
        font-size: 16px;
        line-height: 18px;
      }

      @at-root html[lang='de'] & {
        font-size: 16px;
        line-height: 18px;
      }

      @at-root html[lang='pt'] & {
        font-size: 15px;
        line-height: 18px;
      }

      @at-root html[lang='es'] & {
        font-size: 15px;
        line-height: 18px;
      }

      @at-root html[lang='pl'] & {
        font-size: 16px;
        line-height: 18px;
      }

      @at-root html[lang='uk'] & {
        font-size: 16px;
        line-height: 18px;
      }

      @at-root html[lang='it'] & {
        font-size: 16px;
        line-height: 18px;
      }
    }

    .labelBlock4Price {
      width: auto;
      white-space: nowrap;
      color: #221e1a;
      text-align: right;
      font-size: 17px;
      font-weight: 700;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-left: 10px;
    }

    .labelBlock4PriceBlock2 {
      margin-top: 12px;

      .labelBlock4Price {
        align-items: flex-end;
        color: #e44a08;
      }
    }

    .labelBlock4Divider {
      margin-top: 11px;
      margin-bottom: 11px;
      width: 100%;
      height: 2px;
      background-color: #eae5da;
      border-radius: 4px;
    }

    .labelBlock4PriceBlock3 {
      height: 40px;
      border-radius: 12px;
      background: rgba(190, 226, 188, 0.6);
      padding: 0 8px;

      .labelBlock4PriceText {
        display: flex;
        align-items: center;
        font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
          sans-serif);
        font-size: 19px;
        font-weight: 700;
        line-height: 24px;
      }

      .labelBlock4Price {
        color: #03935d;
      }
    }
  }

  .labelBlockButtons {
    margin-top: 6px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0 20px;

    .labelBlockButtons {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .labelBlockButton1 {
      position: relative;
      width: 100%;
      height: 60px;
      min-height: 60px;
      border-radius: 48px;
      background: var(--ed-brand, #ae66f6);
      display: flex;
      padding: 16px;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      @at-root html[lang='en'] & {
        padding: 16px 25px;
      }

      letter-spacing: -0.4px;

      &:active {
        opacity: 0.8;
      }

      p {
        color: #fff;
        text-align: center;
        font-size: 22px;
        font-weight: 700;
        line-height: 22px;

        @at-root html[lang='ru'] & {
          letter-spacing: -0.4px;
          font-size: 18px;
        }

        @at-root html[lang='pl'] & {
          letter-spacing: -0.4px;
          font-size: 18px;
        }

        @at-root html[lang='fr'] & {
          letter-spacing: -0.4px;
          font-size: 18px;
        }

        @at-root html[lang='it'] & {
          font-size: 20px;
        }

        @at-root html[lang='pt'] & {
          font-size: 20px;
        }

        @at-root html[lang='es'] & {
          font-size: 21px;
        }

        @at-root html[lang='uk'] & {
          letter-spacing: -0.4px;
          font-size: 18px;
        }
      }

      .arrow {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        display: none;

        @at-root html[lang='en'] & {
          display: block;
        }
      }
    }

    .labelBlockButton2 {
      margin-top: 15px;
      width: 100%;
      background-color: transparent;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }

      p {
        color: #221e1a;
        font-size: 17px;
        font-weight: 400;
        line-height: 22px;
        text-decoration: underline;
      }
    }
  }
}

// policy wrapper
.policyWrapper {
  width: 100%;
  background-color: #29a073;
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 450px;

  .guaranteeWrapper {
    width: 100%;
    max-width: 375px;
    margin-top: 32px;
    padding: 0 20px;
  }

  .faqWrapper {
    width: 100%;
    margin-top: 15px;
    padding: 0 20px;
  }

  .supportWrapper {
    width: 100%;
    padding: 0 20px;
  }

  .footerWrapper {
    width: 100%;
    margin-top: 32px;
    background-color: #00af7c;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
